import { jsx } from "react/jsx-runtime";
import React, { useState } from "react";
import classNames from "classnames";
import TgSelect from "../TgSelect";
export const DropdownCell = ({
  options,
  isMulti,
  initialValue,
  finishEdit,
  cancelEdit,
  dataTest
}) => {
  const [v, setV] = useState(
    isMulti ? initialValue.split(",").map((v2) => ({ value: v2, label: v2 })) : initialValue
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames("tg-dropdown-cell-edit-container", {
        "tg-dropdown-cell-edit-container-multi": isMulti
      }),
      children: /* @__PURE__ */ jsx(
        TgSelect,
        {
          small: true,
          multi: isMulti,
          autoOpen: true,
          value: v,
          onChange: (val) => {
            if (isMulti) {
              setV(val);
              return;
            }
            finishEdit(val ? val.value : null);
          },
          ...dataTest,
          popoverProps: {
            onClose: (e) => {
              if (isMulti) {
                if (e && e.key === "Escape") {
                  cancelEdit();
                } else {
                  finishEdit(
                    v && v.map ? v.map((v2) => v2.value).filter((v2) => v2).join(",") : v
                  );
                }
              } else {
                cancelEdit();
              }
            }
          },
          options: options.map((value) => ({ label: value, value }))
        }
      )
    }
  );
};
